export type UiState = {
  global: {
    isMiniCartOpen: boolean;
  };
};

const state: UiState = {
  global: {
    isMiniCartOpen: false,
  },
};

export default state;
